import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ferris/react/components/button/Button';
import parse from 'html-react-parser';

function SubmissionForm(props) {
    const {
        title, description, ctaLabel, setShowVacasa
    } = props;
    return (
        <div className="ulx-pm-submission-form-container">
            <h3>{title}</h3>
            <p>{parse(description)}</p>
            <Button
                htmlButtonType="button"
                type="primary"
                onClick={() => setShowVacasa(false)}
            >
                {ctaLabel}
            </Button>
        </div>
    );
}
SubmissionForm.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ctaLabel: PropTypes.string.isRequired,
    setShowVacasa: PropTypes.func.isRequired
};

export default SubmissionForm;
